module.exports = __webpack_public_path__ + "static/media/dailyRoutine_1_zh_HK.4e8aa1b1.png";